module.exports = __webpack_public_path__ + "static/media/N1_Onboarding.5506fee9.png";